import { render } from "./ColorSliders.vue?vue&type=template&id=eb42a3ce&scoped=true"
import script from "./ColorSliders.vue?vue&type=script&lang=js"
export * from "./ColorSliders.vue?vue&type=script&lang=js"

import "./ColorSliders.vue?vue&type=style&index=0&id=eb42a3ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb42a3ce"]])

export default __exports__